import React from 'react'

import { BASE_URL, ICONS } from '../../constants'
import { PREFERENCES } from '../../user/constants'

import { useSigEvent, useIncident } from '../hooks'
import { useUserPreference } from '../../user/hooks'

import IncidentDate from '../../incidents/components/IncidentDate'

import styles from './SigEventsListItem.module.css'

const SigEventsListItem = ({ eventId }) => {
  const [
    { subject, createdDate, modifiedDate, incidentId },
    { select },
  ] = useSigEvent(eventId)
  const [incident] = useIncident(incidentId)
  const type = (incident && incident.type) || {
    name: 'unknown',
    icon: 'SigEventIconsOther.png',
  }
  const sortBy = useUserPreference(PREFERENCES.SIGEVENT_DISPLAY_ORDER)

  return (
    <li className={styles.item} onClick={select}>
      <img
        className={styles.icon}
        alt={type.name}
        src={BASE_URL + ICONS.AI.BORDERLESS.DIR + type.icon}
      />
      <div className={styles.title}>{subject}</div>
      <IncidentDate
        style={styles.timestamp}
        date={sortBy === 'created' ? createdDate : modifiedDate}
      >
        {sortBy === 'created' ? 'Created' : 'Modified'}
      </IncidentDate>
    </li>
  )
}
export default SigEventsListItem
